import { RouteProperties } from "@/api_framework/api_modals/Routers";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { IUIPage } from "@/app_redux/reducers/reducer_interface";

interface IUseRouteInfoReturn {
  routeState: RouteProperties;
  meta: IUIPage;
}
const useRouteInfo = (routeId: string): IUseRouteInfoReturn => {
  const routeState: RouteProperties = useAppSelector((state) => {
    if (Object.keys(state.routes.auth).includes(routeId)) {
      return state.routes.auth[routeId];
    } else {
      return state.routes.public[routeId];
    }
  });
  const meta = useAppSelector((state) => state.root.UIPage);
  return { routeState, meta };
};

export default useRouteInfo;
